export * from "./shared";
export * from "./mobilepay";
export * from "./vipps";
export * from "./applepay";
export * from "./googlepay";